import { z } from 'zod';

import {
  ACTIVITY_GROUP_BY_TYPES,
  ACTIVITY_AGGREGATION_LEVELS,
  ACTIVITY_CRITICAL_TYPES,
  ACTIVITY_DISPLAY_TYPES,
  ActivityAggregationLevel,
  ActivityCriticalType,
  ActivityDisplayTypes,
  ActivityGroupByType,
} from 'business/shift-report/report-analyze/pages/activity-analyze/types';
import { RangeFilters, filterTypeSchema } from 'technical/range-filters/types';
import { dateRangeSchema } from 'technical/types';
import {
  NumberRangeValue,
  numberRangeSchema,
} from 'ui/form/number-range-input';

interface CommonFilters {
  groupByType: ActivityGroupByType;
  aggregationLevel: ActivityAggregationLevel;
  criticalType: ActivityCriticalType;
  vChartScale: NumberRangeValue;
  displayType: ActivityDisplayTypes;
}

export type ActivityAnalyzeRangeFilters = RangeFilters<CommonFilters>;
export type ActivityAnalyzeCheckedActivities = string[];

export type ReportActivityAnalyzeFilters = {
  filters: ActivityAnalyzeRangeFilters;
  checkedActivities: ActivityAnalyzeCheckedActivities;
};

export const activityAnalyzeFiltersSchema = z.object({
  filterType: filterTypeSchema,
  dateRange: dateRangeSchema.optional(),
  ringRange: numberRangeSchema.optional(),
  groupByType: z.enum(ACTIVITY_GROUP_BY_TYPES),
  aggregationLevel: z.enum(ACTIVITY_AGGREGATION_LEVELS),
  criticalType: z.enum(ACTIVITY_CRITICAL_TYPES),
  vChartScale: numberRangeSchema,
  displayType: z.enum(ACTIVITY_DISPLAY_TYPES),
});

export const activityAnalyzeCheckedActivitiesSchema = z.array(z.string());

export const activityAnalyzeLocalStorageSchema = z.object({
  filters: activityAnalyzeFiltersSchema.optional(),
  checkedActivities: activityAnalyzeCheckedActivitiesSchema.optional(),
});

export type ActivityAnalyzeLocalStorageSchema = z.infer<
  typeof activityAnalyzeLocalStorageSchema
>;
